import PageBody from "../PageBody";
import NewNotification from "../components/pages/notifications/NewNotification";
const NewNotificationPage = () => {
  return (
    <PageBody>
      <NewNotification />
    </PageBody>
  );
};

export default NewNotificationPage;
